import { HeroTitle } from "@/pages/common/Home/components/HeroTitle"

import styles from "./styles.module.scss"

export const Intro = () => {
  return (
    <div className={styles.intro}>
      <HeroTitle>
        <span>
          <strong>AVA Trainer</strong>
        </span>

        <span>Analytics</span>
      </HeroTitle>
    </div>
  );
};
